"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var loom_text_formatting_1 = require("loom-text-formatting");
/**
 * Takes in a FormattedTextResult and returns an array of JSX.Elements containing tags to be
 * rendered
 *
 * @param nestedResultText FormattedTextResult used to parse through and convert each element to an
 * array of JSX.Elements
 * @returns React.ReactNode to be rendered
 */
function convertToJSX(resultText) {
    var elements = [];
    resultText.forEach(function (element, index) {
        if (typeof element === "string") {
            elements.push(element);
        }
        else if (element.content) {
            var content = convertToJSX(element.content);
            switch (element.format) {
                case loom_text_formatting_1.Format.Emphasized: {
                    elements.push(React.createElement("em", { key: index }, content));
                    break;
                }
                case loom_text_formatting_1.Format.Link: {
                    elements.push(React.createElement("a", __assign({ key: index }, element.properties), content));
                    break;
                }
                case loom_text_formatting_1.Format.Strong: {
                    elements.push(React.createElement("strong", { key: index }, content));
                    break;
                }
            }
        }
    });
    return elements;
}
var FormattedString = function (props) {
    var text = props.inputText;
    // Get the formatted text from the textFormatter and then convert to JSX
    var formattedText = loom_text_formatting_1.textFormatter(text);
    // Convert the FormattedTextResult react elements
    return React.createElement(React.Fragment, null, convertToJSX(formattedText));
};
exports.default = FormattedString;
//# sourceMappingURL=FormattedString.js.map